import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=3803ea5c&scoped=true&"
import script from "./uploadImg.vue?vue&type=script&lang=ts&"
export * from "./uploadImg.vue?vue&type=script&lang=ts&"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=3803ea5c&prod&lang=scss&scoped=true&"
import style1 from "./uploadImg.vue?vue&type=style&index=1&id=3803ea5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803ea5c",
  null
  
)

export default component.exports